import React from "react";
import "../styles/policy.css";

const Terms = () => {
  return (
    <div>
      <div className="legal_page">
        <div className="container">
          <div className="legal_page_content">
            <div className="container">
              <h2>GENERAL TERMS AND CONDITIONS OF USE AND SALE</h2>
              <p className="updated">Updated on 19/06/2025</p>

              <p>
                These General Terms and Conditions of Use and Sale (hereinafter
                referred to as the <span className="definition">"Terms"</span>)
                govern access to and use of the <strong>QualiCheck</strong>{" "}
                application (hereinafter referred to as the{" "}
                <span className="definition">"Platform"</span>), which is an
                initiative of:
              </p>

              <div className="company-info">
                <p>
                  <strong>Logic Services</strong>
                </p>
                <p>Chemin de la Lande</p>
                <p>4801 Verviers - Belgium</p>
                <p>Entreprise N° (BCE/VAT): BE1001826490</p>
                <p>
                  Email:{" "}
                  <a href="mailto:info@logic-services.com">
                    info@logic-services.com
                  </a>
                </p>
                <p>
                  Phone: <a href="tel:+32492565007">+32 492 56 50 07</a>
                </p>
              </div>

              <p>
                (hereinafter referred to as{" "}
                <span className="definition">"Logic Services"</span> or the{" "}
                <span className="definition">"Seller"</span>)
              </p>

              <p>
                By accessing or using the Platform, users agree to be bound by
                these Terms, which form a binding agreement between the user and
                Logic Services.
              </p>
            </div>
            <h2>GENERAL TERMS AND CONDITIONS OF USE </h2>
            <h3> 1. Scope of application </h3>
            <p>
              {" "}
              These general conditions of use (hereinafter the "GTCU") apply to
              any visit to or use of the Platform and its information by an
              Internet user (hereinafter the "User").{" "}
            </p>
            <p>
              {" "}
              By visiting or using the Platform, Users acknowledge that they
              have read these Terms and Conditions of Use and expressly accept
              the rights and obligations set out therein..{" "}
            </p>
            <p>
              {" "}
              Exceptionally, the provisions of the GTCU may be waived by written
              agreement. These derogations may consist of the modification,
              addition or deletion of the clauses to which they relate and have
              no effect on the application of the other provisions of the GTCU.{" "}
            </p>
            <p>
              {" "}
              We reserve the right to modify our GTCU at any time, without prior
              notice, but we undertake to apply the provisions that were in
              force at the time you used our Platform.{" "}
            </p>
            <h3> 2. Plateform</h3>
            <p>
              {" "}
              <strong> a. Access and navigation </strong>{" "}
            </p>
            <p>
              {" "}
              We take all reasonable and necessary steps to ensure the smooth
              operation, security and accessibility of our Platform. However, we
              cannot offer a guarantee of absolute operability and our actions
              must therefore be considered as covered by an obligation of means.{" "}
            </p>
            <p>
              {" "}
              Any use of the Platform is always at the User's own risk. We are
              therefore not liable for any damage that may result from
              malfunctions, interruptions, defects or harmful elements on the
              Platform.{" "}
            </p>
            <p>
              {" "}
              We reserve the right to restrict access to the Platform or to
              interrupt its operation at any time, without obligation to give
              prior notice.{" "}
            </p>
            <p>
              <strong> b. Content </strong>{" "}
            </p>
            <p>
              {" "}
              Logic Services largely determines the content of the Platform and
              takes great care with the information on the Platform. We take all
              possible measures to keep our Platform as complete, accurate and
              up-to-date as possible, even when the information on it is
              provided by third parties. We reserve the right to modify, add to
              or delete the Platform and its content at any time, without
              incurring any liability.{" "}
            </p>
            <p>
              {" "}
              Logic Services cannot offer an absolute guarantee concerning the
              quality of the information present on the Platform. It is
              therefore possible that this information is not always complete,
              accurate, sufficiently precise or up to date. Consequently, Logic
              Services cannot be held responsible for any direct or indirect
              damage that the User may suffer as a result of the information
              presented on the Platform.{" "}
            </p>
            <p>
              {" "}
              If any content on the Platform infringes the law or the rights of
              third parties, or is otherwise unethical, we ask you to inform us
              as soon as possible by e-mail so that we can take appropriate
              measures.{" "}
            </p>
            <p>
              {" "}
              Any downloading from the Platform always takes place at the User's
              own risk. Logic Services cannot be held responsible for any direct
              or indirect damage resulting from these downloads, such as loss of
              data or damage to the User's computer system, which are entirely
              and exclusively the responsibility of the User.{" "}
            </p>

            <p>
              {" "}
              <strong> c. Services reserved for registered Users </strong>{" "}
            </p>
            <p>
              <i> 1) Registration </i>{" "}
            </p>
            <p>
              {" "}
              Access to certain services is subject to registration by the User.{" "}
            </p>
            <p>
              {" "}
              Registration and access to the Platform's services are reserved
              exclusively for legally competent individuals who have completed
              and validated the registration form available online on the
              Platform, as well as these GCU.{" "}
            </p>
            <p>
              {" "}
              When registering, Users undertake to provide accurate, truthful
              and up-to-date information about themselves and their civil
              status. The User must also regularly check the data concerning
              him/her in order to maintain its accuracy..{" "}
            </p>
            <p>
              {" "}
              The User must therefore provide a valid e-mail address, to which
              the Platform will send confirmation of registration for its
              services. An e-mail address may not be used more than once to
              register for services.{" "}
            </p>
            <p>
              {" "}
              Any communication sent by the Platform and its partners is
              therefore deemed to have been received and read by the User. The
              User therefore undertakes to regularly check messages received at
              this e-mail address and, if necessary, to reply within a
              reasonable time.{" "}
            </p>
            <p> Only one entry is permitted per person. </p>
            <p>
              {" "}
              The User will be given a login enabling him/her to access an area
              reserved for him/her (hereinafter referred to as the "Personal
              Area"), in addition to entering his/her password.{" "}
            </p>
            <p>
              {" "}
              Users can change their login and password online in their Personal
              Area. The password is personal and confidential, and the User
              undertakes not to communicate it to third parties.{" "}
            </p>
            <p>
              {" "}
              In any event, Logic Services reserves the right to refuse a
              request to register for services on the Platform if the User fails
              to comply with the GTCU.{" "}
            </p>
            <p>
              {" "}
              <i> 2) Unsubscription </i>{" "}
            </p>
            <p>
              {" "}
              Regularly registered Users may unsubscribe at any time by visiting
              the dedicated page in their Personal Area. Any unsubscription from
              the Platform will be effective once the User has completed the
              form provided for this purpose, within the following period: 4
              weeks.{" "}
            </p>

            <h3> 3. Links to other websites </h3>
            <p>
              {" "}
              The Platform may contain links or hyperlinks to external websites.
              Such links do not automatically imply that a relationship exists
              between Logic Services and the external website or even that an
              implicit agreement exists with the content of these external
              websites.{" "}
            </p>
            <p>
              {" "}
              Logic Services has no control over external websites. We are
              therefore not responsible for the safe and correct operation of
              hyperlinks and their final destination. As soon as the User clicks
              on the hyperlink, he or she leaves the Platform. We cannot
              therefore be held liable for any subsequent damage.{" "}
            </p>

            <h3> 4. Intellectual property </h3>
            <p>
              {" "}
              The structure of the Platform, as well as the texts, graphics,
              images, photographs, sounds, videos, databases, computer
              applications, etc. which make it up or which are accessible via
              the Platform are the property of the publisher and are protected
              as such by the laws in force in respect of intellectual property.{" "}
            </p>
            <p>
              {" "}
              Any representation, reproduction, adaptation or partial or total
              exploitation of the content, trademarks and services offered by
              the Platform, by any process whatsoever, without the prior,
              express and written authorisation of the publisher, is strictly
              prohibited, with the exception of those elements expressly
              designated as free of rights on the Platform.{" "}
            </p>
            <p>
              {" "}
              The Platform User is granted a limited right to access, use and
              display the Platform and its content. This right is granted on a
              non-exclusive, non-transferable basis and may only be used for
              personal, non-commercial purposes. Except with prior written
              consent, Users are not authorised to modify, reproduce, translate,
              distribute, sell or communicate to the public, in whole or in
              part, the protected elements of the Platform and its content.{" "}
            </p>
            <p>
              {" "}
              Users are prohibited from entering data on the Platform that would
              modify or be likely to modify its content or appearance.{" "}
            </p>

            <h3> 5. Protection of personal data </h3>
            <p>
              {" "}
              The personal data provided by the User when visiting or using the
              Platform are collected and processed by Logic Services exclusively
              for internal purposes. Logic Services assures its Users that it
              attaches the utmost importance to the protection of their privacy
              and their personal data, and that it is always committed to
              communicating clearly and transparently on this point.{" "}
            </p>
            <p>
              {" "}
              Logic Services undertakes to comply with the relevant applicable
              legislation, namely the Law of 8 December 1992 on the protection
              of privacy with regard to the processing of personal data and the
              European Regulation of 27 April 2016 on the protection of
              individuals with regard to the processing of personal data and on
              the free movement of such data.{" "}
            </p>
            <p>
              {" "}
              The User's personal data is processed in accordance with the
              Privacy Policy available on the Platform.{" "}
            </p>

            <h3> 6. Applicable law and jurisdiction </h3>
            <p> These GTCU are governed by Belgian law.. </p>
            <p>
              {" "}
              In the event of a dispute and in the absence of an amicable
              agreement, the dispute will be brought before the courts of the
              judicial district where Logic Services has its registered office.{" "}
            </p>

            <h3> 7. General provisions </h3>
            <p>
              {" "}
              Logic Services reserves the right to modify, extend, delete, limit
              or interrupt the Platform and associated services at any time,
              without prior notice, and without incurring any liability.{" "}
            </p>
            <p>
              {" "}
              In the event of a breach of the GTCU by the User, Logic Services
              reserves the right to take appropriate sanctions and remedial
              measures. In particular, Logic Services reserves the right to
              refuse the User any access to the Platform or to our services,
              either temporarily or permanently. These measures may be taken
              without giving any reason and without prior notice. Logic Services
              cannot be held liable for such measures or give rise to any form
              of compensation.{" "}
            </p>
            <p>
              {" "}
              The illegality or invalidity, in whole or in part, of any
              provision of our GTCU shall not affect the validity and
              enforceability of the remaining provisions. In such a case, we
              have the right to replace the provision with another valid
              provision of similar scope..{" "}
            </p>

            <h3> II. GENERAL TERMS AND CONDITIONS OF SALE </h3>

            <h3> 1. Scope of application </h3>
            <p>
              {" "}
              These general terms and conditions of sale (hereinafter referred
              to as the "GTCS") define the reciprocal rights and obligations in
              the event of the purchase of products or services on the Platform
              by a User (hereinafter referred to as the "Customer").{" "}
            </p>
            <p>
              {" "}
              The GTCS express the entirety of the obligations of the parties.
              The Customer is deemed to accept them unreservedly, failing which
              the order will not be validated..{" "}
            </p>
            <p>
              {" "}
              In exceptional circumstances, derogations may be made to the
              provisions of the GTCS, provided that such derogations have been
              agreed in writing. Such derogations may consist in the
              modification, addition or deletion of the clauses to which they
              relate and have no effect on the application of the other
              provisions of the GTCS.{" "}
            </p>
            <p>
              {" "}
              Logic Services reserves the right to modify the GTC from time to
              time. The modifications will be applicable as soon as they are put
              online for all purchases made after this date.{" "}
            </p>

            <h3> 2. Online shop </h3>
            <p>
              {" "}
              Via the Platform, the Vendor provides the Customer with an online
              shop presenting the products or services sold, without the
              photographs having any contractual value.{" "}
            </p>
            <p>
              {" "}
              The products and services are described and presented as
              accurately as possible. However, in the event of errors or
              omissions in the presentation, the Seller may not be held liable
              in this respect.{" "}
            </p>
            <p> Products and services are offered subject to availability.. </p>
            <p> Prices and taxes are specified in the online shop.. </p>

            <h3> 3. Price </h3>
            <p>
              {" "}
              The Seller reserves the right to change its prices at any time by
              publishing them online..{" "}
            </p>
            <p>
              {" "}
              Only the prices indicated and the taxes in force at the time of
              the order will apply, subject to availability on that date.{" "}
            </p>
            <p>
              {" "}
              Prices are given in euros and do not include any delivery charges,
              which are indicated and invoiced in addition before the order is
              validated by the Customer.{" "}
            </p>
            <p>
              {" "}
              The total amount of the order (including all taxes) and, where
              applicable, delivery costs is indicated before final validation of
              the order form.{" "}
            </p>

            <h3> 4. Order online </h3>
            <p>
              {" "}
              The Customer may fill in an order form online, using an electronic
              form. By completing the electronic form, the Customer accepts the
              price and description of the products or services.{" "}
            </p>
            <p>
              {" "}
              For the order to be validated, the Customer must accept these
              General Terms and Conditions of Sale by clicking on the following
              link.{" "}
            </p>
            <p>
              {" "}
              The Customer must provide a valid e-mail address, billing address
              and, where applicable, delivery address. Any exchanges with the
              Vendor may take place via this e-mail address.{" "}
            </p>
            <p>
              {" "}
              In addition, the Customer must choose the delivery method and
              validate the payment method.{" "}
            </p>
            <p>
              {" "}
              The Vendor reserves the right to block the Customer's order in the
              event of nonpayment, incorrect address or any other problem with
              the Customer's account, until the problem has been resolved.{" "}
            </p>

            <h3> 5. Order confirmation and payment </h3>
            <p>
              The Vendor retains ownership of the items ordered until full
              payment for the order has been received.. a. Payment{" "}
            </p>
            <p>
              {" "}
              The Customer makes the payment at the time of final validation of
              the order, using the chosen method of payment. This validation
              takes the place of a signature..{" "}
            </p>
            <p>
              {" "}
              The Customer guarantees the Vendor that he/she has the necessary
              authorisations to use this method of payment and acknowledges that
              the information given for this purpose is proof of his/her consent
              to the sale and to the payment of the sums due for the order.{" "}
            </p>
            <p>
              {" "}
              The Vendor has set up a procedure for verifying orders and means
              of payment in order to provide a reasonable guarantee against any
              fraudulent use of a means of payment, including by asking the
              Customer for identification data.{" "}
            </p>
            <p>
              {" "}
              In the event of refusal to authorise payment by bank card by the
              accredited organisations or in the event of non-payment, the
              Seller reserves the right to suspend or cancel the order and its
              delivery.{" "}
            </p>
            <p>
              {" "}
              The Vendor also reserves the right to refuse an order from a
              Customer who has not paid in full or in part for a previous order
              or with whom a payment dispute is in progress. b. Confirmation{" "}
            </p>
            <p>
              {" "}
              As soon as confirmation of the purchase and payment have been
              received, the Seller will send the Customer an invoice, unless the
              invoice is delivered with the order.{" "}
            </p>
            <p>
              {" "}
              The Customer may request that the invoice be sent to an address
              other than the delivery address by sending a request to this
              effect to Customer Services (see contact details below) before
              delivery.{" "}
            </p>
            <p>
              {" "}
              In the event that a service or product is unavailable, the Vendor
              will inform the Customer by e-mail as soon as possible in order to
              replace it or cancel the order for this product and possibly
              refund the relevant price, the remainder of the order remaining
              firm and definitive.{" "}
            </p>

            <h3> 6. Subscriptions </h3>
            <p>
              {" "}
              This article applies in addition to the other provisions of the
              contract for any subscription taken out by the Customer via the
              Platform..{" "}
            </p>
            <p> The subscription entitles you to: </p>
            <ul>
              <li>access to the QualiCheck application</li>
            </ul>
            <p>The Customer will be invoiced as follows : </p>
            <ul>
              <li> Monthly subscription </li>
              <li>Monthly number of checklists</li>
            </ul>
            <p>All subscriptions are for 1 month.. </p>
            <h3>7. Proof of payment </h3>
            <p>
              {" "}
              Communications, orders and payments between the Customer and the
              Vendor may be proven by means of computerised registers kept in
              the Vendor's computer systems under reasonable security
              conditions. Order forms and invoices are archived on a reliable
              and durable medium considered, in particular, as a means of proof.{" "}
            </p>

            <h3> 8. Guarantees </h3>
            <p>
              {" "}
              The Seller guarantees that the products or services conform to the
              contract in accordance with the law in force at the time the
              contract is concluded.{" "}
            </p>

            <h3> 9. Right of withdrawal </h3>
            <p>
              {" "}
              If the Customer is a consumer, he hereby waives his right of
              withdrawal in order to be supplied as soon as possible after the
              conclusion of the contract.{" "}
            </p>

            <h3> 10. Data protection </h3>
            <p>
              {" "}
              The Seller will keep proof of the transaction, including the order
              form and the invoice, in its computer systems under reasonable
              security conditions.{" "}
            </p>
            <p>
              {" "}
              The Seller guarantees to protect the Customer's personal data in
              accordance with the Privacy Policy available on the Platform.{" "}
            </p>

            <h3> 11. Force majeure </h3>
            <p>
              {" "}
              If the Seller is prevented, in whole or in part, from fulfilling
              the order due to an unforeseen circumstance beyond its control,
              this is deemed to be force majeure.{" "}
            </p>
            <p>
              {" "}
              In the event of force majeure, the Seller is authorised to suspend
              performance of the order, in whole or in part, for the duration of
              the force majeure. The Vendor shall immediately inform the
              Customer.{" "}
            </p>
            <p>
              {" "}
              If the force majeure continues for more than 90 days without
              interruption, each of the parties to the contract will have the
              right to terminate the contract unilaterally, by registered letter
              sent to the other party. The services already provided by the
              Vendor will nevertheless be invoiced proportionally to the
              Customer..{" "}
            </p>

            <h3> 12. Independence of clauses </h3>
            <p>
              {" "}
              The illegality or invalidity, in whole or in part, of any
              provision of these GTC shall have no impact on the validity and
              application of the other provisions. The Seller reserves the right
              to replace the illegal or invalid provision with another valid
              provision of similar scope.{" "}
            </p>

            <h3> 13. Applicable law and jurisdiction </h3>
            <p> These GTCS are governed by Belgian law. </p>
            <p>
              {" "}
              In the event of a dispute and in the absence of an amicable
              agreement, the dispute will be brought before the courts of the
              judicial district of the Seller's registered office.{" "}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;
